const ListLoading = () => {
    return (
        <div style={{ display: "flex", justifyContent: "center", marginTop: "40px" }} className="list-loader-container">
            <div className='listloader'></div>
        </div>

    )
}
export default ListLoading